export default "/ticket-preview.8b36ff6c-ce169e.png";